var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 7.25C0.875 3.45305 3.95305 0.375 7.75 0.375H35.25C39.0471 0.375 42.125 3.45305 42.125 7.25V34.75C42.125 38.5471 39.0471 41.625 35.25 41.625H7.75C3.95305 41.625 0.875 38.5471 0.875 34.75V7.25ZM7.75 4.95833C6.48436 4.95833 5.45833 5.98436 5.45833 7.25V34.75C5.45833 36.0157 6.48436 37.0417 7.75 37.0417H35.25C36.5157 37.0417 37.5417 36.0157 37.5417 34.75V7.25C37.5417 5.98436 36.5157 4.95833 35.25 4.95833H7.75ZM10.7129 14.7962C11.6078 13.9013 13.0588 13.9013 13.9538 14.7962L18.5371 19.3796C19.432 20.2745 19.432 21.7255 18.5371 22.6204L13.9538 27.2038C13.0588 28.0987 11.6078 28.0987 10.7129 27.2038C9.81793 26.3089 9.81793 24.8578 10.7129 23.9629L13.6758 21L10.7129 18.0371C9.81793 17.1422 9.81793 15.6912 10.7129 14.7962ZM21.5 25.5833C21.5 24.3176 22.526 23.2917 23.7917 23.2917H30.6667C31.9324 23.2917 32.9583 24.3176 32.9583 25.5833C32.9583 26.849 31.9324 27.875 30.6667 27.875H23.7917C22.526 27.875 21.5 26.849 21.5 25.5833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/codeIcon.5baa7911a14dc1d790fa26b47d490d5c.svg";
export { ForwardRef as ReactComponent };